import api from "./api";
import { notifyEngagement } from "../utils/engagementEvents";

const unwrap = (payload) => payload?.data ?? payload;

export const commentsService = {
  // Batch comment counts for feed cards. Returns [{target_type, target_id, count}].
  getCounts: async (targetType, targetIds) => {
    if (!targetIds || targetIds.length === 0) return [];
    const params = new URLSearchParams({ target_type: targetType });
    targetIds.forEach((id) => params.append("target_ids", id));
    const response = await api.get(`/api/v1/comments/counts?${params}`);
    return unwrap(response.data) || [];
  },

  // Newest-first page of comments plus total. offset pages older comments.
  list: async (targetType, targetId, { limit = 20, offset = 0 } = {}) => {
    const params = new URLSearchParams({ limit, offset });
    const response = await api.get(
      `/api/v1/comments/${targetType}/${targetId}?${params}`
    );
    return unwrap(response.data);
  },

  create: async (targetType, targetId, contentHtml) => {
    const response = await api.post(
      `/api/v1/comments/${targetType}/${targetId}`,
      { content_html: contentHtml }
    );
    // Announced from the service layer, alongside the reaction and recognition
    // signals, so a fourth credit source has one obvious place to hook into.
    notifyEngagement("comment");
    return unwrap(response.data);
  },

  update: async (commentId, contentHtml) => {
    const response = await api.patch(`/api/v1/comments/${commentId}`, {
      content_html: contentHtml,
    });
    return unwrap(response.data);
  },

  remove: async (commentId) => {
    const response = await api.delete(`/api/v1/comments/${commentId}`);
    return unwrap(response.data);
  },
};

export default commentsService;
